import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/category/all' },
    { label: '关于我们', path: '/about' },
  ],
  categories: [
    { label: '国产剧', path: '/category/chinese' },
    { label: '韩剧', path: '/category/korean' },
    { label: '美剧', path: '/category/american' },
    { label: '日剧', path: '/category/japanese' },
    { label: '综艺', path: '/category/variety' },
    { label: '动漫', path: '/category/anime' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-3 cursor-pointer">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">
                小草影院
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              小草虽小，视界无限。致力于为广大影视爱好者提供最新、最全、最流畅的电视剧在线观看体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-3">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-3">
              分类浏览
            </h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950 mb-3">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs"></i>
                </div>
                contact@xiaocaoyingyuan.com
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-wechat-line text-xs"></i>
                </div>
                小草影院官方
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-weibo-line text-xs"></i>
                </div>
                @小草影院官方微博
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 小草影院 xiaocaoyingyuan.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 cursor-pointer" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}